module.exports = __webpack_public_path__ + "img/bg-sect-3.13734cca.png";